/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1Competence202,
  PostApiV1Competence400,
  PostApiV1Competence401,
  PostApiV1Competence500,
  PostApiV1CompetenceMutationRequest,
  PostApiV1CompetenceMutationResponse,
} from "../../types/competenceRegistroController/PostApiV1Competence.ts";
import { competenceViewModelSchema } from "../competenceViewModelSchema.ts";
import { createCompetenceRequestViewModelSchema } from "../createCompetenceRequestViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1Competence202Schema = z.lazy(
  () => competenceViewModelSchema,
) as unknown as ToZod<PostApiV1Competence202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1Competence400Schema =
  z.any() as unknown as ToZod<PostApiV1Competence400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1Competence401Schema =
  z.any() as unknown as ToZod<PostApiV1Competence401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1Competence500Schema =
  z.any() as unknown as ToZod<PostApiV1Competence500>;

export const postApiV1CompetenceMutationRequestSchema = z.lazy(
  () => createCompetenceRequestViewModelSchema,
) as unknown as ToZod<PostApiV1CompetenceMutationRequest>;

export const postApiV1CompetenceMutationResponseSchema = z.lazy(
  () => postApiV1Competence202Schema,
) as unknown as ToZod<PostApiV1CompetenceMutationResponse>;
